// AutoGenerated
export class SesGrupTopluSiraNoGuncelleRequestModel {
    constructor(
        siraliIDList: string[],
    ) {
        this.siraliIDList = siraliIDList;
    }

    siraliIDList: string[];
}